<template>
  <div class="material-list">
    <el-tabs v-model="materialData.tab" type="border-card">
      <el-tab-pane v-if=" materialData.videos" name="video">
        <div slot="label">
          视频<span>({{ materialData.videos.length }})</span>
        </div>
        <div class="material-content">
          <div
            v-for="(item, index) in materialData.videos"
            :key="index"
            class="material-item material-item-video"
          >
            <div class="item-border">
              <div class="item-content">
                <div class="video-item">
                  <video :src="item.url[0].url" controls />
                </div>
                <div class="video-item">
                  <el-image
                    fit="contain"
                    :src="item.url[0].thumb_url"
                  />
                  <div class="img-func">
                    <el-button
                      class="el-button-scale"
                      icon="el-icon-zoom-in"
                      circle
                      style="background-color: #3333336e; color: #fff"
                      @click.stop="openViewer(materialData.videos, index)"
                    />
                    <el-button
                      class="el-button-replace"
                      size="mini"
                      type="primary"
                      @click="replaceCover(item)"
                    >
                      更换封面
                    </el-button>
                  </div>
                </div>
              </div>
              <i
                class="el-icon-error item-close"
                @click="delectMaterial(materialData.videos, index)"
              />
              <el-tooltip effect="dark" :content="item.name" placement="bottom-start">
                <div class="title">{{ item.name }}</div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if=" materialData.images" name="image">
        <div slot="label">
          图片<span>({{ materialData.images.length }})</span>
        </div>
        <div class="material-content">
          <div
            v-for="(item, index) in materialData.images"
            :key="index"
            class="material-item"
          >
            <div class="item-border">
              <div class="item-content" style="position: relative;">
                <el-image
                  fit="contain"
                  :src="item.url[0].thumb_url"
                />
                <div class="img-func">
                  <el-button
                    class="el-button-scale"
                    icon="el-icon-zoom-in"
                    circle
                    @click.stop="openViewer(materialData.images, index)"
                  />
                </div>
              </div>
              <i
                class="el-icon-error item-close"
                @click="delectMaterial(materialData.images, index)"
              />
              <el-tooltip effect="dark" :content="item.name" placement="bottom-start">
                <div class="title">{{ item.name }}</div>
              </el-tooltip>
            </div>
          </div>
        </div>
        <el-image-viewer
          v-if="show_viewer"
          :z-index="3000"
          :initial-index="url_index"
          :on-close="closeViewer"
          :url-list="url_list"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  model: {
    prop: 'materialData', // 指向props的参数名
    event: 'change', // 事件名称
  },
  props: {
    /**
     * 素材数据
     */
    materialData: {
      type: [Object, Array],
      required: true,
    },
    /**
     * 素材选项卡值
     */
    materialTab: {
      type: String,
      default: 'video',
    },
  },
  data() {
    return {
      show_viewer: false,
      url_list: [],
    };
  },
  methods: {
    // 打开预览幻灯片
    openViewer: function(list, index) {
      this.url_list = list.map((item) => {
        return item.url[0].thumb_url;
      });
      this.url_index = index;
      this.show_viewer = true;
    },
    // 关闭预览幻灯片
    closeViewer: function() {
      this.show_viewer = false;
    },
    // 删除素材
    delectMaterial: function(list, index) {
      list.splice(index, 1);
    },
    // 更换封面
    replaceCover: function(item) {
      this.$emit('replace-cover', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.material-list {
  padding: 20px 0;
  /deep/ .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
  .material-content {
    height: 500px;
    padding: 10px;
    background-color: rgb(224, 224, 232);
    overflow: auto;
    .material-item {
      display: inline-block;
      width: 20%;
      height: 40%;
      padding: 10px;

      .item-border {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 10px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        display: flex;
        flex-direction: column;
        padding-bottom: 0;
        .item-content {
          flex:1;
          min-height: 0;
        }
        video,
        .el-image {
          width: 100%;
          height: 100%;
          background-color: #333;
          object-fit: contain
        }
        .img-func {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          overflow: hidden;
          transition: all .3s;

          .el-button.el-button-scale {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 36px;
            height: 36px;
            margin: auto;
            background-color: #3333336e; color: #fff;
            &:hover {
              transform: scale(1.2);
            }
          }
          .el-button-replace {
            position: absolute;
            right: -1px;
            bottom: -29px;
          }
          &:hover {
            .el-button-replace {
              bottom: -1px;
            }
          }
        }
        .item-close {
          position: absolute;
          right: -5px;
          top: -5px;
          font-size: 15px;
          cursor: pointer;
        }
      }
      &.material-item-video {
        width: 50%;
        .video-item {
          position: relative;
          float: left;
          width: 50%;
          height: 100%;
          &:nth-child(1) {
            padding-right: 5px;
          }
          &:nth-child(2) {
            padding-left: 5px;
          }
        }
      }
    }
  }
  .title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
